import YogaMultipackCarousel from './YogaMultipackCarousel'

export default YogaMultipackCarousel
// eslint-disable-next-line import/export
export * from './YogaMultipackCarousel'
